<section class="body-section">
    <div class="container">
        <main>
            <div class="col-md-12 user-top-body-header d-flex justify-content-between">
                <div class="mobileBg-div">
                    <div class="buttonsList mobile-version">
                        <ul>
                            <li>
                                <button onclick="history.back()"><img
                                        src="../../../../assets/images/profile/leftIcon.svg" alt=""></button>
                            </li>
                            <li>
                                <a href="{{shareurl}}" target="_blank">
                                    <button><img src="../../../../assets/images/profile/shareIcon.svg" alt=""></button>
                                </a>
                            </li>
                        </ul>
                        <img src="../../../../assets/images/profile/bg.svg" alt="" class="profileBg">
                    </div>
                </div>
                <div class="left-section">
                    <div class="media">
                        <div class="media-left">

                            <div *ngIf="profileDetails" class="user-image  ">
                                <img src="{{profileDetails.profilepic}}" alt="">
                                <div class="activeStatus">
                                    <button (click)="onDownloadClick('bottom')">Active</button>
                                </div>
                            </div>
                            <div *ngIf="profileDetails" class="media-body">
                                <div class="tag" *ngIf="loggedInUser?.userdata?.rolename ==='proplayer' ? 'PRO':''">

                                    {{this.loggedInUser?.userdata?.rolename ==='proplayer' ? 'PRO':''}}
                                </div>
                                <!-- <div *ngIf="isProfileComplete" class="name">
                                    <h4>{{profileDetails?.fullName}}</h4>
                                </div> -->
                                <div class="name">
                                    <h4>{{profileDetails?.firstName ? profileDetails.fullName:""}}
                                        <span class="user-status  "><img (mouseover)="op.toggle($event)" />
                                        </span>
                                    </h4>
                                    <div class="userdataDetails">
                                        <div class="dateOfB">
                                            <div class="gender">
                                                {{profileDetails.gender}}
                                            </div>
                                            <div class="vLine">

                                            </div>
                                            <div class="AgeList">
                                                {{profileDetails.age}} Yrs
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <!-- <p-overlayPanel #op>
                                    <div class="name">
                                        <h4>
                                            <div class="show-progress" style="display: block!important;">

                                                <div class="subscriber-header">
                                                    <div class="status-button">
                                                        <div class="title">
                                                            Level:
                                                        </div>
                                                        <div class="meida-body">

                                                            <div class="level {{userBadge}}"><img> {{userBadge}}</div>
                                                        </div>
                                                    </div>
                                                 
                                                </div>
                                                <hr>
                                                <div class="col-md-12">
                                                    <div class="note">
                                                        <p *ngIf="userBadge!='Gold'">Spend More {{amountToSpend |
                                                            currency: 'INR'}} to Reaching
                                                            {{userBadge=='Bronze'?'Silver':'Gold'}} Level.</p>
                                                        <p *ngIf="userBadge=='Gold'">Gold Level Reached.</p>
                                                      
                                                    </div>
                                                    <div class="progress" *ngIf="userBadge!='Gold'">


                                                        <div class="progress-bar" role="progressbar"
                                                            [style.width.%]="cashSpendPercent"
                                                            [attr.aria-valuenow]="cashSpendPercent" aria-valuemin="0"
                                                            aria-valuemax="100"></div>
                                                    </div>
                                                    <div class="spending-amount" *ngIf="userBadge!='Gold'">
                                                        <div class="total-spend">Total Spent: {{cashSpend | currency:
                                                            'INR'}}</div>

                                                        <div class="left-spend">Left: {{amountToSpend | currency:
                                                            'INR'}}</div>
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="list">
                                                    <ul>
                                                        <li>
                                                            <div class="media">
                                                                <div class="media-left icon">
                                                                    <img src="assets/img/category/bronze_medal-1.png"
                                                                        alt="">
                                                                </div>
                                                                <div class="media-body">
                                                                    Bronze - Free

                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="media">
                                                                <div class="media-left icon">
                                                                    <img src="assets/img/category/silver_medal-1.png"
                                                                        alt="">
                                                                </div>
                                                                <div class="media-body">
                                                                    Silver - Minimum spend of 15k


                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="media">
                                                                <div class="media-left icon">
                                                                    <img src="assets/img/category/gold_medal-1.png"
                                                                        alt="">
                                                                </div>
                                                                <div class="media-body">
                                                                    Gold - Minimum spend of 25k
                                                                </div>
                                                            </div>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>

                                        </h4>

                                    </div>

                                </p-overlayPanel> -->

                                <div class="col-md-12">
                                    <!-- <p class="id d-flex">
                                        <span class="id"> <a href="#" class="flag">
                                                <img src="assets/img/players/flag2.png" alt="">
                                            </a> ID: {{profileDetails.id}}</span>
                                        <span class="line-separator m-none">|</span>
                                        <span>Age: {{profileDetails.age}}</span>
                                        <span class="line-separator">|</span>
                                        <span>
                                            Form:
                                            <span *ngFor="let win_loss of winloss">
                                                {{win_loss?.winOrLoss}}
                                            </span>


                                        </span>

                                    </p> -->

                                    <!-- <div class="mt-1"><span class="club">Academy:</span> <a
                                            href="/en/organisation/4646/ultim8-tennis-league-u8l"
                                            class="club-name">{{profileDetails.clubName}}</a> <a
                                            href="javascript:void(0);" class="x-remove-club"
                                            style="text-decoration: none;"></a>
                                    </div> -->
                                    <!-- <div class="mobile-verison subscribtion">
                                        <button class="subBtn" (click)="onDownloadClick('bottom')"><img src="../../../../assets/images/profile/subscribe.svg" alt=""></button>
                                    </div> -->
                                    <div class="mobile-verison subscribtion">
                                        <p>Member since {{ profileDetails.created_at | date: 'MMMM yyyy'}} <span><img
                                                    src="../../../../assets/images/profile/plus-sign.svg" alt=""></span>
                                        </p>
                                    </div>
                                    <div class="profiles-buttons">
                                        <div class="edite-profile-section">
                                            <a [routerLink]="(!isProfileCompleted) ? '../profile-edit2' : '../profile-edit'"
                                                class="btn editProfileBtn">
                                                <span><img src="../../../../assets/images/profile/edit-02.svg"
                                                        alt=""></span> Edit Profile
                                            </a>
                                        </div>
                                        <div class="ref_container">
                                            <div class="cool_btn edite-profile-section">

                                                <a href="{{shareurl}}" target="_blank">
                                                    <button class="ref_share btn">
                                                        <span class="ref_url"> <img
                                                                src="../../../../assets/images/profile/shareBtnIcon.svg"
                                                                alt="">
                                                        </span>
                                                        Referral Code
                                                    </button>
                                                </a>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rightBtn">
                        <button (click)="onDownloadClick('bottom')"><img
                                src="../../../../assets/images/profile/subscribe.svg" alt=""></button>
                    </div>

                </div>


                <div class="right-side-section">
                    <div class="box spending-box">

                        <div class="pie-chart">
                            <p-chart type="doughnut" [data]="data" [options]="options"></p-chart>
                            <div class="overall-spending">
                                <h4>skill
                                </h4>
                                <span>{{playerRating}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class=" col-md-12 bottom-container tablesections KYC-notice" *ngIf="profileDetails?.age > 17">
                <div class="header-container box w-100">
                    <div class=" col-md-12 bottom-container tablesections KYC-notices">
                        <div class="media">
                            <div class="media-left">
                                <div class="icon">
                                    <i class='bx bx-paperclip'></i>
                                </div>
                            </div>
                            <div class="media-body" *ngIf="!presentKycData">
                                <h2>KYC Incomplete</h2>

                                <p> To ensure the security and compliance of our platform, we
                                    kindly
                                    request you to complete the Know Your Customer (KYC) process by uploading the
                                    required
                                    documents.

                                </p>

                            </div>
                            <div class="media-right" [pTooltip]="tooltipContent"
                                [ngClass]="{ '!isProfileComplete': 'disabled' }" *ngIf="!presentKycData">
                                <button (click)="onDownloadClick('bottom')" [disabled]="!isProfileComplete">Update
                                    KYC</button>
                                <!-- <button routerLink="../kyc" [disabled]="!isProfileComplete">Update KYC</button> -->
                            </div>
                            <div class="media-right" *ngIf="kycVerificationComplete">
                                <button routerLink="../view-kyc">View KYC</button>
                            </div>
                            <div class="media-right" *ngIf="presentKycData && !kycVerificationComplete">
                                <!-- <button routerLink="../kyc" >Edit KYC</button> -->
                                <button (click)="onDownloadClick('bottom')">Edit KYC</button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <!-- <div class="mainPageTitle ">
                <div class="tab-div">
                    <ul class="tabList">
                        <li>
                            <button class="active-btn" (click)="onDownloadClick('bottom')">
                             Overview
                            </button>
                        </li>
                        <li>
                            <button (click)="onDownloadClick('bottom')"> 
                                Analytics
                            </button>
                        </li>
                        <li>
                            <button (click)="onDownloadClick('bottom')">
                                Academy
                            </button>
                        </li>
                    </ul>
                </div>
            </div> -->
            <!-- <div class=" col-md-12 bottom-container tablesections KYC-notice"
                *ngIf="presentKycData || presentButrejected">
                <div class="header-container box w-100">
                    <div class=" col-md-12 bottom-container tablesections KYC-notices">
                        <div class="media">

                            <div class="media-body">
                                <h2 class="mb-3">KYC Info</h2>

                                <div class="col-md-12">


                                    <p-table class="p2-table-columns show-columns" #dt [value]="bankDetails" [totalRecords]="totalRecords"
                                        [loading]="loading" styleClass="p-datatable-gridlines p-datatable-striped">
                                        <ng-template pTemplate="header" let-columns>
                                            <tr class="desktop-tr">
                                                <th [style]="{'width':'120px'}">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Created Date
                                                    </div>
                                                </th>
                                                <th [style]="{'width':'120px'}">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Bank Name

                                                    </div>
                                                </th>
                                                <th [style]="{'width':'120px'}">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Account Number
                                                    </div>
                                                </th>
                                                <th [style]="{'width':'120px'}">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        IFSC
                                                    </div>
                                                </th>
                                                <th [style]="{'width':'120px'}">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Status
                                                    </div>
                                                </th>
                                                <th [style]="{'width':'120px'}">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Action
                                                    </div>
                                                </th>


                                            </tr>

                                            <tr class="mobile-tr">
                                                <th
                                                    [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Created Date
                                                    </div>
                                                </th>
                                                <th
                                                    [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Bank Name

                                                    </div>
                                                </th>
                                                <th
                                                    [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Account-Number
                                                    </div>
                                                </th>
                                                <th
                                                    [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        IFSC
                                                    </div>
                                                </th>
                                                <th
                                                    [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Status
                                                    </div>
                                                </th>
                                                <th
                                                    [style]="{'width':'100%', 'display':'block!important', 'padding':'7px 8px !important'  }">
                                                    <div class="p-d-flex p-jc-between p-ai-center">
                                                        Action
                                                    </div>
                                                </th>


                                            </tr>


                                        </ng-template>
                                        <ng-template pTemplate="body" let-kycData>
                                            <tr class="p-selectable-row">

                                                <td>
                                                    {{kycData.created_at | date:'d-M-yyyy'}}
                                                </td>
                                                <td>
                                                    {{kycData.bankName}}

                                                </td>

                                                <td>
                                                    {{kycData.bankAccountNumber}}
                                                </td>
                                                <td>
                                                    {{kycData.ifsc}}
                                                </td>

                                                <td class="status-Td">
                                                    <p-tag class="bg-success text-white" *ngIf="kycData.isBankVerified"
                                                        [rounded]="true">Approved</p-tag>
                                                    <p-tag class="bg-warning text-dark"
                                                        *ngIf="!kycData.isBankVerified"
                                                        [rounded]="true">Pending</p-tag>
                                             
                                                </td>
                                                <td>
                                                    <button routerLink="../kyc/{{kycData._id}}/"
                                                        *ngIf="presentKycData && kycData.isBankVerified">View
                                                        Details</button>
                                                    <button routerLink="../kyc"
                                                        *ngIf="!kycData.isBankVerified">Edit Details</button>
                                                </td>

                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary">
                                            <div *ngIf="presentKycData && !presentButrejected"
                                                class="flex align-items-center justify-content-between">
                                                Email admin at <span><a href="mailto:support@tplsport.com"
                                                        style="cursor: pointer;text-decoration: underline; text-transform: lowercase; margin-left: 2px;">
                                                        support@tplsport.com.</a></span> for adding another new KYC
                                                details
                                            </div>
                                        </ng-template>
                                    </p-table>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div> -->
            <div class=" col-md-12 bottom-container tablesections Overview mainD-none">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3 ">
                        <h3 class="section-header">Overview</h3>
                        <div class="year-selector">
                            <!-- <p-dropdown inputId="matchTypes" [options]="matchTypes" placeholder="Select"
                                optionLabel="name"></p-dropdown> -->
                            <!-- <select class="form-select" aria-label="Default select example">
                                <option selected>

                                    Single</option>
                                <option value="1">Double</option>

                            </select> -->
                        </div>
                    </div>
                    <div class="col-md-12 main-box-div ">
                        <table *ngIf="skillinfoDetails" class="fullWidth w-100 text-center">
                            <thead>
                                <tr>
                                    <th>{{careerDetails}}</th>
                                    <th>Career</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <span class="big"><strong id="win-loss-curr-year">{{skillinfoDetails
                                                ===undefined ? 0 :
                                                skillinfoDetails?.currentYear?.totalWins}}-{{skillinfoDetails
                                                ===undefined ? 0
                                                :skillinfoDetails?.currentYear?.totalLosses}}</strong></span>
                                        <br><span>W-L</span>
                                    </td>
                                    <td><span class="big"><strong id="car-win-los">{{skillinfoDetails ===undefined ? 0 :
                                                skillinfoDetails?.overAllStatistics?.totalWins}}-{{skillinfoDetails
                                                ===undefined ?
                                                0:skillinfoDetails?.overAllStatistics?.totalLosses}}</strong></span>
                                        <br><span>W-L</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span class="big"><strong
                                                id="events-partic-curr-year">{{this.tournamentParticapation?.currentYear[0]?.totalParticipation}}</strong></span>
                                        <br><span>Tournament Participation</span>
                                    </td>
                                    <td><span class="big"><strong
                                                id="car-events-partic">{{this.tournamentParticapation?.items[0]?.careerTournamentParticipation}}</strong></span>
                                        <br><span>Tournament Participation</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <div class=" col-md-12 bottom-container tablesections mainD-none">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3">
                        <h3 class="section-header">Opponents
                        </h3>
                    </div>
                    <div class="not-found-section w-100 " *ngIf="opponentList.length == 0">
                        <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                            <h4>Not found!</h4>
                            <p>Opponent list not found!</p>
                        </div>
                    </div>
                    <div class="col-md-12 main-box-div" *ngIf="opponentList.length > 0">
                        <div class="opponents-info-body">
                            <div class="col-6 opponents-info ">
                                <swiper [config]="Opponents" class="opponents-info-cards-wrapper">
                                    <div *ngFor="let opponent of opponentList"
                                        class=" swiper-slide rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                                        <!---->
                                        <div class="rin-card-header"><img
                                                src={{opponent?.opponents_data?.userData?.profilepic}}></div>
                                        <div class="rin-card-body">
                                            <div class="first-name">{{opponent?.opponents_data?.userData?.fullName}}
                                            </div>

                                        </div>
                                        <div class="rin-card-footer">
                                            <div class="opponents-info-card-footer">
                                                <hr>
                                                <div class="matches-counter">
                                                    {{opponent?.opponents_data?.tournamentPlayed}}</div> <span
                                                    class="matches-text">matches</span>
                                            </div>
                                        </div>
                                    </div>
                                </swiper>
                            </div>


                            <div class="highest-jump-wrapper" *ngIf="highestSkillJump">
                                <div class="highest-skill-jump-wrapper">
                                    <div class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                                        <div class="rin-card-title">
                                            <div class="highest-skill-jump-header">
                                                <div>
                                                    Highest Skill Jump
                                                </div>
                                            </div>
                                        </div>
                                        <div class="rin-card-header">
                                            <div class="highest-skill-jump-date">
                                                <div><i class='bx bx-calendar'></i>
                                                    &nbsp; {{highestSkillJump?.created_at|date:'dd/MM/y'}}
                                                </div>
                                            </div>
                                            <hr>
                                        </div>
                                        <div class="rin-card-body">
                                            <div class="highest-skill-jump-body">
                                                <div class="left-box">
                                                    <div class="player-box">
                                                        <div class="p-name"><span><span><a href="#" class="flag">
                                                                        <img src="assets/img/players/flag2.png" alt="">
                                                                    </a>
                                                                    &nbsp;{{highestSkillJump?.userName}}
                                                                </span> <!----> <!----></span></div>
                                                        <div class="p-name"><span><span><a href="#" class="flag">
                                                                        <img src="assets/img/players/flag2.png" alt="">
                                                                    </a>
                                                                    &nbsp;{{highestSkillJump?.opponentName}}
                                                                </span> <!----> <!----></span></div>
                                                    </div>
                                                    <div class="rating-box">
                                                        <div class="p-rating">
                                                            <span>{{playerRatingForHighestSkillJump}}</span><span
                                                                class="rating-diff">&nbsp;{{plusminus}}{{lessplayerRating}}</span>
                                                            <!---->
                                                            <!---->
                                                        </div>
                                                        <div class="p-rating"><span>{{opponentRating}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="right-box">
                                                    <div class="score-box">
                                                        <div>{{highestSkillJump?.player1val}}</div>
                                                    </div>
                                                    <div class="score-box">
                                                        <div>{{highestSkillJump?.player2val}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="rin-card-footer">
                                            <hr> <a
                                                routerLink="/tournaments/factsheet/{{highestSkillJump.tournamentId}}"
                                                class="event-name">
                                                {{highestSkillJump?.tournamentName}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="Show-more-btn">
                            <button routerLink="../profile-opponents">Show More</button>
                        </div>
                    </div>

                </div>

            </div>

            <div class=" col-md-12 bottom-container tablesections mainD-none">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3">
                        <h3 class="section-header">Last Tournaments Played

                        </h3>
                    </div>
                    <div class="col-md-12 main-box-div">
                        <div class="not-found-section w-100 " *ngIf="opponentList.length == 0">
                            <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                                <h4>Not found!</h4>
                                <p>Come Back to see details!</p>
                            </div>
                        </div>
                        <div class="opponents-info-body Last-events-played ">
                            <swiper [config]="Top_config" class="swiper-container clients-slider zoom-effect-container">
                                <div *ngFor="let tournament of tournamentList " class="swiper-slide ">
                                    <div class="col-md-12 ">
                                        <div class="opponents-info-body Last-events-played w-100">
                                            <div class="swiper mySwiper  w-100">
                                                <div class="swiper-wrapper">
                                                    <div class="swiper-slide">
                                                        <div
                                                            class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                                                            <div class="rin-card-title"><span
                                                                    class="rin-type-label tournament">
                                                                    tournament
                                                                </span></div> <!---->
                                                            <div class="rin-card-body">
                                                                <div class="last-events-played-card-body">
                                                                    <div class="rin-card rin-card-bg-secondary rin-card-no-shadow "
                                                                        [ngClass]="tournament?.opponents_data?.player1val > tournament?.opponents_data?.player2val ? 'rin-card-border winner' : 'rin-card-border loser'">
                                                                        <div class="rin-card-title"><img
                                                                                src={{item?.profilepic}}>
                                                                        </div>
                                                                        <div class="rin-card-header"><span
                                                                                class="flag-icon flag-icon-in"></span>
                                                                            <a class="">
                                                                                <div class="first-name">
                                                                                    {{item?.fullName}}</div>
                                                                            </a> <a class="">
                                                                                <!-- <div class="last-name">Shinde</div> -->
                                                                            </a>
                                                                        </div> <!----> <!---->
                                                                    </div>
                                                                    <div
                                                                        class="rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border">
                                                                        <div class="rin-card-title"><img
                                                                                src={{tournament?.opponents_data?.userData?.profilepic}}>
                                                                        </div>
                                                                        <div class="rin-card-header"><span
                                                                                class="flag-icon flag-icon-in"></span>
                                                                            <a class="">
                                                                                <div class="first-name">
                                                                                    {{tournament?.opponents_data?.userData?.fullName
                                                                                    }}</div>
                                                                            </a> <a class="">
                                                                                <!-- <div class="last-name">Dixit</div> -->
                                                                            </a>
                                                                        </div> <!----> <!---->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="rin-card-footer">
                                                                <div><span class="result-label">
                                                                        {{tournament?.opponents_data?.player1val
                                                                        }}
                                                                        -
                                                                        {{tournament?.opponents_data?.player2val
                                                                        }}</span>


                                                                    <span class="d-flex"><span
                                                                            class="icon-rin-sports-tennis"></span>&nbsp;
                                                                        <a
                                                                            routerLink="/tournaments/factsheet/{{tournament?.opponents_data?.tournamentData[0]?._id}}"><span
                                                                                class="event-link-ellipsis">{{tournament?.opponents_data?.tournamentData[0]?.name}}</span></a></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </swiper>


                        </div>
                        <div class="Show-more-btn">
                            <button routerLink="../profile-tournament">Show More</button>
                        </div>
                    </div>
                </div>

            </div>


            <div class="bottom-container  chart-div profile mainD-none">
                <div class="col-md-12 d-flex justify-content-end ">
                    <p-dropdown [ngModel]="selectedYear" [options]="yearOptions" (onChange)="onClickYear($event)"
                        placeholder="Select year" optionLabel="year" [filter]="true"></p-dropdown>
                </div>

                <div class="bottom-container__left">
                    <div class="box spending-box">
                        <div class="header-container justify-content-start chart-heading">
                            <h3 class="section-header">Ranking Movement</h3>
                            <p class="text-left mb-0">
                                Historic data for player
                            </p>

                        </div>
                        <p-chart type="line" [data]="rankData" [options]="basicRankOptions"></p-chart>
                    </div>
                </div>
                <div class="bottom-container__left">
                    <div class="box spending-box">
                        <div class="header-container justify-content-start chart-heading">
                            <h3 class="section-header">Skill History</h3>
                            <p class="text-left mb-0 hidden">
                                Historic data for player
                            </p>

                        </div>
                        <div class="not-found-section d-none">
                            <div class="col-md-12 not-found-body  w-100" style="padding: 1rem;"><img
                                    src="assets/img/logo/not-found.gif" alt="">
                                <h4>Coming Soon!</h4>

                            </div>
                        </div>
                        <p-chart type="line" [data]="skillsData" [options]="basicOptions" class=""></p-chart>
                    </div>
                </div>

            </div>
            <div class="dashboardFoooter">
                <div class="logoutbtn">
                    <button (click)="signOut()">
                        <div class="icon">
                            <img src="../../assets/images/login/logout.svg" alt="">
                        </div>
                        <div class="text">
                            Log out
                        </div>
                    </button>
                </div>
                <div class="footerText">
                    <h3>
                        We are TPL
                    </h3>
                    <p>
                        Crafted with <span>❤</span> in India
                    </p>
                </div>
            </div>
        </main>
    </div>
</section>
<p-dialog header="Reason of Rejection" [(visible)]="rejectKycReasonView" [modal]="true" [style]="{ width: '500px' }"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [draggable]="false" [resizable]="false"
    class="modal-payment-select">
    <div>
        {{viewReason}}
    </div>
</p-dialog>


<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>

        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>

        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>